// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__pp4Gp","title":"AfterBackImages_title__30508","images":"AfterBackImages_images__138F8"};